import gql from 'graphql-tag';

export default gql`
  mutation updateXFormAnswer(
    $data: String
    $formAnswerXuid: String!
  ) {
    updateXFormAnswer(
      data: $data
      formAnswerXuid: $formAnswerXuid
    ) {
      xuid
    }
  }
`;
